import React, { Component } from 'react'
import style from './style.css'
import ImageRatio from '../../atoms/ImageRatio'
import ActionBtnIcon from '../../../SPRINTA/molecules/ActionBtnIcon'
import { numberFormat } from '../../../SPRINTA/helpers/Formatter';
import FontIcon from '../../../SPRINTA/atoms/FontIcon'


class HotelBox extends Component {

    render() {
        let image = this.props.image || require('./imagemNull.jpg')
        return (
            <div className={`${style.box}`}>
                <div>
                    <div style={{cursor: 'pointer', position: 'relative'}} onClick={() => this.props.handleShow()}>
                        <ActionBtnIcon
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                zIndex: 9
                            }}
                            icon='search'
                            theme='rounded-orange' />
                        <ImageRatio image={image} ratio='1x1' />
                    </div>

                    <div className={style.boxContent}>
                        <div className={`${style.title}`}>
                            {this.props.title.length > 50 ? this.props.title.substr(0, 50) + '...' : this.props.title}
                        </div>

                        <ul className={style.infoitems}>
                           <li>
                              <span>
                                 A partir de R${numberFormat(this.props.starting_price, 2, ',', '.')}
                              </span>
                           </li>
                           <li>
                              <FontIcon name="admin_hotel" /> <span style={{marginLeft: '5px'}}>até {this.props.max_guests} pessoas</span>
                           </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
  }

  export default HotelBox



// WEBPACK FOOTER //
// ./src/components/molecules/HotelBox/index.js